<template>
  <bim-text
    :type="type"
    class="text-center"
    :bold="bold"
  >{{ $t(template, { count: our_model_count }) }}</bim-text>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: 'accent'
    },
    bold: {
      type: Boolean,
      default: true
    },
    template: {
      type: String,
      default: 'Мы создали более {count} моделей, вот некоторые из них:'
    }
  },
  computed: {
    ...mapState('counters', [
      'our_model_count'
    ])
  }
}
</script>
